import { Loader } from "lucide-react";
import { Suspense, useEffect } from "react";
import { useLocation, useRoutes } from "react-router-dom";
import { FeedbackForm } from "./components/feedback-form/FeedbackForm";
import { Header } from "./einstein/components/common/header/header";
import { featureFlags } from "./lib/config/featureFlags";
import { useAppDispatch, useAppSelector } from "./lib/store/dynamicStore";
import { initializeAuth } from "./lib/store/features/auth/authSlice";
import { routes } from "./routes/index";

function App() {
	const dispatch = useAppDispatch();
	const { isLoading, isAuthenticated } = useAppSelector((state) => state.auth);
	const element = useRoutes(routes);
	const location = useLocation();

	useEffect(() => {
		if (featureFlags.isAuthEnabled) {
			// Always initialize auth to handle MSAL redirects
			dispatch(initializeAuth());
		}

		const deploymentEnv = import.meta.env.VITE_CUSTOM_ENV_NAME;
		if (deploymentEnv === "production") {
			document.title = "Einstein";
		} else {
			document.title = "Einstein - Development";
		}
	}, [dispatch]);

	const isLoginPage = location.pathname === "/login";

	// Don't show loader on login page
	if (isLoading && featureFlags.isAuthEnabled && !isLoginPage) {
		return <Loader />;
	}

	return (
		<>
			{!isLoginPage && isAuthenticated && <Header />}
			{isAuthenticated && <FeedbackForm />}
			<Suspense fallback={<Loader />}>{element}</Suspense>
		</>
	);
}

export default App;
